import React from 'react';
import { Box, Typography } from '@mui/material';
import { GridPreviewProps } from '../types';
import { parseGridPosition } from '../utils';

export const GridPreview: React.FC<GridPreviewProps> = ({ 
    gridColumns, 
    gridRows, 
    widgets, 
    highlightWidget, 
    excludeWidget 
}) => {
    const cellSize = 20;
    const gap = 1;
    
    const renderCells = () => {
        const cells = [];
        
        for (let row = 1; row <= gridRows; row++) {
            for (let col = 1; col <= gridColumns; col++) {
                const isOccupied = widgets
                    .filter(w => w !== excludeWidget)
                    .some(widget => {
                        const colPos = parseGridPosition(widget.gridColumn);
                        const rowPos = parseGridPosition(widget.gridRow);
                        return col >= colPos.start && col < (colPos.start + colPos.span) &&
                               row >= rowPos.start && row < (rowPos.start + rowPos.span);
                    });
                
                const isHighlighted = highlightWidget && 
                    col >= highlightWidget.colStart && col < (highlightWidget.colStart + highlightWidget.colSpan) &&
                    row >= highlightWidget.rowStart && row < (highlightWidget.rowStart + highlightWidget.rowSpan);
                
                const isOverlapping = isOccupied && isHighlighted;
                
                cells.push(
                    <Box
                        key={`${col}-${row}`}
                        sx={{
                            width: cellSize,
                            height: cellSize,
                            border: '1px solid #ddd',
                            backgroundColor: isOverlapping ? '#ffcdd2' : // Red for overlap
                                           isHighlighted ? '#c8e6c9' :   // Green for highlight
                                           isOccupied ? '#e0e0e0' :      // Gray for occupied
                                           'white',                       // White for empty
                            gridColumn: col,
                            gridRow: row
                        }}
                    />
                );
            }
        }
        
        return cells;
    };
    
    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Grid Preview:</Typography>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${gridColumns}, ${cellSize}px)`,
                    gridTemplateRows: `repeat(${gridRows}, ${cellSize}px)`,
                    gap: `${gap}px`,
                    border: '2px solid #ddd',
                    borderRadius: 1,
                    p: 1,
                    backgroundColor: '#f5f5f5'
                }}
            >
                {renderCells()}
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mt: 1, fontSize: '0.75rem' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ width: 12, height: 12, backgroundColor: '#c8e6c9', border: '1px solid #ddd' }} />
                    <span>Selected Widget</span>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ width: 12, height: 12, backgroundColor: '#e0e0e0', border: '1px solid #ddd' }} />
                    <span>Occupied</span>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ width: 12, height: 12, backgroundColor: '#ffcdd2', border: '1px solid #ddd' }} />
                    <span>Overlap</span>
                </Box>
            </Box>
        </Box>
    );
};